//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MBD.js";
import "../no/Builder.js";
let d=[[],[[["types"],"EnableSurfaceFinishType",{},1,0],[["types"],"DisableSurfaceFinishType",{},1,0],[[],"GetModifier",{R_:{modifier:"MBD.BooleanCriteriaBuilder"}},0,0],[[],"GetAllaround",{R_:{allaround:"MBD.BooleanCriteriaBuilder"}},0,0],[[],"GetRoughnessValue",{R_:{roughnessValue:"MBD.StringCriteriaBuilder"}},0,0]],[]];
SPLM.MBD.PMIQuerySFSCriteriaBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MBD.PMIQuerySFSCriteriaBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MBD.PMIQuerySFSCriteriaBuilder.JaPmiqueryFcfcriteriaBuilderSfsMaterialRemovalType = Object.freeze({
    "None" : "None", "Required" : "Required", "Prohbited" : "Prohbited"});

export default SPLM;